var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.name === 'Kiosk')?_c('div',{staticClass:"qr-story d-flex align-items-end",on:{"click":_vm.printURL}},[_c('vue-qr',_vm._b({staticClass:"w-100"},'vue-qr',_vm.qrConfig,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }